// extracted by mini-css-extract-plugin
module.exports = {"nav":"AuthNavbar_nav__2xQiG","brand":"AuthNavbar_brand__zO-Ty","actions":"AuthNavbar_actions__1pAky"};